import React, { Fragment, useEffect, useState } from "react";
import Swal from "sweetalert2";
import "./pricingTool.css";
import Form from "../../components/form";
import Header from "../../components/header";
import { BiArrowBack } from "react-icons/bi";
import { connect } from "react-redux";
import { fetchManufacturerStateRequest } from "../../store/actions/manufacturerStateAction";
import { fetchPricingOtherDetailRequest } from "../../store/actions/pricingOtherDetailsAction";
import {
  fetchPricingRequest,
  fetchPricingReset,
} from "../../store/actions/pricingDataAction";
import pricingToolYear from "./pricingToolYear.json";
import marginPercentage from "./marginPercentage.json";
import { FcInfo } from "react-icons/fc";
import { useQuery } from "../../utils/useQuery";
import { matchRange } from "../../utils/matchRange";

function PricingTool({ ...props }) {
  const [manufacturer, setManufacturer] = useState([
    {
      label: "Select Manufacturer",
      value: "",
    },
  ]);
  const [model, setModel] = useState([
    {
      label: "Select Model",
      value: "",
    },
  ]);
  const [state, setState] = useState([
    {
      label: "Select State",
      value: "",
    },
  ]);
  const [engineHours, setEngineHours] = useState([
    {
      label: "Select Engine Hours",
      value: "",
    },
  ]);
  const [tyreHealth, setTyreHealth] = useState([
    {
      label: "Select Tyre Health",
      value: "",
    },
  ]);

  const [selectedManufacturer, setSelectedManufacturer] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedEngineHours, setSelectedEngineHours] = useState("");
  const [selectedTyreHealth, setSelectedTyreHealth] = useState("");
  const [selectedModelYear, setSelectedModelYear] = useState("");
  const [otherCost, setOtherCost] = useState("");
  const [selectedMargin, setSelectedMargin] = useState("");

  const [selectedPriceType, setSelectedPriceType] = useState("selling");

  const queryParams = useQuery();
  const priceTypeQuery = queryParams.get("price_type");
  const manufacturerQuery = queryParams.get("manufacturer");
  const stateQuery = queryParams.get("state");
  const modelQuery = queryParams.get("model");
  const engineHoursQuery = queryParams.get("engine_hours");
  const yearQuery = queryParams.get("year");

  //android app buying price queryparams changes.start
  useEffect(() => {
    priceTypeQuery && setSelectedPriceType(priceTypeQuery);
    manufacturerQuery && setSelectedManufacturer(manufacturerQuery);
    stateQuery && setSelectedState(stateQuery);
    modelQuery && setSelectedModel(modelQuery);
    yearQuery && setSelectedModelYear(yearQuery);
  }, [priceTypeQuery, manufacturerQuery, stateQuery, modelQuery, yearQuery]);

  useEffect(() => {
    if (
      (engineHoursQuery || engineHoursQuery === "") &&
      engineHours.length > 0
    ) {
      let matchedEngineHoursRange = matchRange(engineHoursQuery, engineHours);
      setSelectedEngineHours(matchedEngineHoursRange);
    }
  }, [engineHours, engineHoursQuery]);
  //android app buying price queryparams changes.end

  useEffect(() => {
    props.getManufacturerState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.manufacturerStateData && props.manufacturerStateData.status) {
      console.log("Manufacturer State Data:", props.manufacturerStateData.data);
      // Find the actual brand/manufacturer data. It might be in .data or .data.manufacturer or .data.brands
      const rawData = props.manufacturerStateData.data;
      if (!rawData) return;

      let brandList = [];

      if (Array.isArray(rawData)) {
        // Format 1: Flattened array of strings or objects
        brandList = rawData.map((item) => {
          const val =
            typeof item === "object"
              ? item.manufacturer || item.brand || item.label
              : item;
          return { label: val, value: val };
        });
      } else if (rawData.manufacturer && Array.isArray(rawData.manufacturer)) {
        // Format 2: Old object format with .manufacturer array
        brandList = rawData.manufacturer.map((item) => ({
          label: item.manufacturer || item,
          value: item.manufacturer || item,
        }));
      } else if (typeof rawData === "object") {
        // Format 3: New format - brand names are keys
        brandList = Object.keys(rawData)
          .filter((key) => key !== "status" && key !== "message")
          .map((key) => ({
            label: key,
            value: key,
          }));
      }

      if (brandList.length > 0) {
        brandList.sort((a, b) => (a.value > b.value ? 1 : -1));
        const uniqueBrands = [
          ...new Set(brandList.map((a) => JSON.stringify(a))),
        ].map((a) => JSON.parse(a));
        setManufacturer([
          { label: "Select Manufacturer", value: "" },
          ...uniqueBrands,
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.manufacturerStateData]);

  useEffect(() => {
    if (selectedManufacturer !== "" && props.manufacturerStateData?.data) {
      const rawData = props.manufacturerStateData.data;
      console.log(
        `Searching states for: "${selectedManufacturer}" in data:`,
        rawData,
      );

      let stateList = [];
      const manufacturerKey = selectedManufacturer.trim();

      // 1. Check for models nested in the brand object (New Format 3)
      if (!Array.isArray(rawData) && rawData[manufacturerKey]?.models) {
        const mappedModels = rawData[manufacturerKey].models.map((item) => ({
          label: item,
          value: item,
        }));
        setModel([{ label: "Select Model", value: "" }, ...mappedModels]);
      }

      // 2. Try to find states

      // Option A: Format 2 (Parallel arrays in manufacturer/state)
      if (rawData.manufacturer && Array.isArray(rawData.manufacturer)) {
        const manufacturers = rawData.manufacturer;
        const statesArr = rawData.state;
        if (statesArr && Array.isArray(statesArr)) {
          for (let i = 0; i < manufacturers.length; i++) {
            const mName = (
              manufacturers[i]?.manufacturer ||
              manufacturers[i] ||
              ""
            )
              .toString()
              .trim();
            if (mName.toLowerCase() === manufacturerKey.toLowerCase()) {
              if (statesArr[i]) {
                const stateVal = (statesArr[i].state || statesArr[i])
                  .toString()
                  .trim();
                stateList.push({ label: stateVal, value: stateVal });
              }
            }
          }
        }
      }

      // Option B: States nested inside the brand object (New Format 3 variation)
      if (
        stateList.length === 0 &&
        !Array.isArray(rawData) &&
        rawData[manufacturerKey]
      ) {
        const brandObj = rawData[manufacturerKey];
        const possibleStateKeys = ["state", "states", "State", "States"];
        for (const key of possibleStateKeys) {
          if (brandObj[key] && Array.isArray(brandObj[key])) {
            stateList = brandObj[key].map((item) => {
              const val = (item.state || item.label || item).toString().trim();
              return { label: val, value: val };
            });
            break;
          }
        }
      }

      // Option C: Global state list in Format 3
      if (
        stateList.length === 0 &&
        rawData.state &&
        Array.isArray(rawData.state)
      ) {
        stateList = rawData.state.map((item) => {
          const val = (item.state || item.label || item).toString().trim();
          return { label: val, value: val };
        });
      }

      // Finalize state list
      if (stateList.length > 0) {
        stateList.sort((a, b) => (a.value > b.value ? 1 : -1));
        const uniqueStates = [
          ...new Set(stateList.map((a) => JSON.stringify(a))),
        ].map((a) => JSON.parse(a));
        setState([{ label: "Select State", value: "" }, ...uniqueStates]);
      } else {
        console.warn(
          `No states found for manufacturer: ${selectedManufacturer}`,
        );
        setState([{ label: "Select State", value: "" }]);
      }
    } else if (selectedManufacturer === "") {
      setState([{ label: "Select State", value: "" }]);
      setModel([{ label: "Select Model", value: "" }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedManufacturer, props.manufacturerStateData]);

  useEffect(() => {
    if (selectedManufacturer !== "" && selectedState !== "") {
      if (!priceTypeQuery) {
        // Only reset models/tyreHealth if they aren't already available in the manufacturer data
        const rawData = props.manufacturerStateData?.data;
        const hasModels =
          rawData &&
          !Array.isArray(rawData) &&
          rawData[selectedManufacturer]?.models;

        if (!hasModels) {
          setModel([{ label: "Select Model", value: "" }]);
        }

        setTyreHealth([{ label: "Select Tyre Health", value: "" }]);
      }
      setEngineHours([{ label: "Select Engine Hours", value: "" }]);
      setOtherCost("");
      let requestPricingOtherDetail = {
        manufacturer: selectedManufacturer,
        state: selectedState,
      };
      props.getPricingOtherDetail({ requestPricingOtherDetail });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedManufacturer, selectedState]);

  useEffect(() => {
    if (
      props.pricingOthersData &&
      props.pricingOthersData.status &&
      props.pricingOthersData.data
    ) {
      console.log("Pricing Others Data:", props.pricingOthersData.data);
      if (!priceTypeQuery) {
        const modelsSource = Array.isArray(
          props.pricingOthersData.data["models"],
        )
          ? props.pricingOthersData.data["models"]
          : Array.isArray(props.pricingOthersData.data)
            ? props.pricingOthersData.data
            : [];

        if (modelsSource.length > 0) {
          let listModelData = modelsSource.map((item) => ({
            label: item,
            value: item,
          }));
          setModel([{ label: "Select Model", value: "" }, ...listModelData]);
        }

        const tyreHealthSource =
          props.pricingOthersData.data["tyre_health"] || [];
        let listTyreHealthData = tyreHealthSource.map((item) => ({
          label: item,
          value: item,
        }));
        setTyreHealth([
          { label: "Select Tyre Health", value: "" },
          ...listTyreHealthData,
        ]);
      }

      if (props.pricingOthersData.data["engine_hours"]) {
        let listEngineHoursData = props.pricingOthersData.data[
          "engine_hours"
        ].map((item) => ({
          label: item,
          value: item,
        }));
        setEngineHours([
          { label: "Select Engine Hours", value: "" },
          ...listEngineHoursData,
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.pricingOthersData]);

  const sellingPrice = () => {
    if (props.pricingData && props.pricingData.status) {
      if (
        props.pricingData.data?.hasOwnProperty("expected_selling_price_min")
      ) {
        return `₹ ${props.pricingData.data?.["expected_selling_price_min"]} - ₹ ${props.pricingData.data?.["expected_selling_price_max"]}`;
      } else {
        return `₹ ${props.pricingData.data?.["expected_selling_price"]}`;
      }
    }
  };

  const buyingPrice = () => {
    if (props.pricingData && props.pricingData.status) {
      return `₹ ${props.pricingData.data["expected_buying_price_min"]} - ₹ ${props.pricingData.data["expected_buying_price_max"]}`;
    }
  };

  const confidenceMeterImage = () => {
    if (props.pricingData && props.pricingData.status) {
      if (props.pricingData.data?.["confidence"].toLowerCase() === "high") {
        return "../assets/confidence_high.svg";
      } else if (
        props.pricingData.data?.["confidence"].toLowerCase() === "moderate"
      ) {
        return "../assets/confidence_medium.svg";
      } else if (
        props.pricingData.data?.["confidence"].toLowerCase() === "low"
      ) {
        return "../assets/confidence_low.svg";
      } else {
        return "";
      }
    }
  };

  useEffect(() => {
    if (props.pricingData && props.pricingData.status) {
      const data = props.pricingData.data;
      const buyingRange =
        data.expected_buying_price_min && data.expected_buying_price_max
          ? `₹ ${data.expected_buying_price_min} - ₹ ${data.expected_buying_price_max}`
          : "N/A";
      const sellingPriceVal = data.expected_selling_price
        ? `₹ ${data.expected_selling_price}`
        : "N/A";
      const sellingRange =
        data.expected_selling_price_min && data.expected_selling_price_max
          ? `₹ ${data.expected_selling_price_min} - ₹ ${data.expected_selling_price_max}`
          : "N/A";
      const confidence = data.confidence || "-";

      Swal.fire({
        html: `
            <div style="padding: 15px; text-align: left; font-family: 'Inter', system-ui, -apple-system, sans-serif;">
              <h3 style="margin: 0 0 20px 0; font-size: 22px; color: #652078; font-weight: 800; text-align: center; border-bottom: 2px solid #f0f0f0; padding-bottom: 12px;">Price Estimation</h3>
              
              <div style="display: flex; flex-direction: column; gap: 12px; margin-bottom: 20px;">
                <div style="background: #f8f1f9; padding: 12px; border-radius: 12px; border-left: 4px solid #652078;">
                  <span style="display: block; font-size: 12px; color: #7b4b8a; font-weight: 600; text-transform: uppercase; margin-bottom: 4px; letter-spacing: 0.5px;">Expected Buying Range</span>
                  <span style="font-weight: 700; font-size: 19px; color: #333;">${buyingRange}</span>
                </div>

                <div style="background: #f1f8f9; padding: 12px; border-radius: 12px; border-left: 4px solid #207378;">
                  <span style="display: block; font-size: 12px; color: #4b868a; font-weight: 600; text-transform: uppercase; margin-bottom: 4px; letter-spacing: 0.5px;">Expected Selling Price</span>
                  <span style="font-weight: 700; font-size: 19px; color: #333;">${sellingPriceVal}</span>
                </div>

                <div style="background: #f1f2f9; padding: 12px; border-radius: 12px; border-left: 4px solid #203578;">
                  <span style="display: block; font-size: 12px; color: #4b5a8a; font-weight: 600; text-transform: uppercase; margin-bottom: 4px; letter-spacing: 0.5px;">Expected Selling Range</span>
                  <span style="font-weight: 700; font-size: 19px; color: #333;">${sellingRange}</span>
                </div>
              </div>

              <div style="display: flex; flex-direction: column; align-items: center; padding: 15px; background: white; border: 1px solid #eeeeee; border-radius: 16px; margin-bottom: 15px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);">
                ${confidenceMeterImage() ? `<img src="${confidenceMeterImage()}" alt="Confidence" style="width: 90px; margin-bottom: 10px;"/>` : ""}
                <span style="font-size: 18px; font-weight: 800; color: #333; margin-bottom: 2px;">${confidence.toUpperCase()}</span>
                <span style="font-size: 11px; text-transform: uppercase; letter-spacing: 1.5px; color: #999; font-weight: 600;">Confidence Meter</span>
              </div>

              ${
                selectedPriceType === "buying"
                  ? `
                <div style="padding: 12px; border-radius: 10px; background-color: #fff9e6; display: flex; align-items: flex-start; gap: 10px; border: 1px solid #ffeeba;">
                  <img src="https://cdn.iconscout.com/icon/premium/png-256-thumb/information-1534465-1300527.png?f=webp&w=128" alt="info" width="18px" style="margin-top: 2px; opacity: 0.8;"/>
                  <span style="font-size: 12px; color: #856404; line-height: 1.5;">Prices shown are inclusive of <strong>${selectedMargin}</strong> dealer margin.</span>
                </div>
              `
                  : ""
              }
            </div>
          `,
        customClass: {
          container: "pricing-swal-container",
        },
        confirmButtonColor: "#652078",
        confirmButtonText: "Done",
        showCloseButton: true,
        width: "400px",
      }).then((res) => {
        if (res) {
          props.pricingReset();
          if (selectedPriceType === "buying" && priceTypeQuery) {
            handleRedirect();
          }
        }
      });
    } else if (props.pricingData && !props.pricingData.status) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: props.pricingData.message,
        confirmButtonColor: "#652078",
      }).then((res) => {
        if (res) {
          props.pricingReset();
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.pricingData]);

  const handleSubmit = (e) => {
    //submit

    e.preventDefault();
    if (
      selectedPriceType === "selling" &&
      selectedManufacturer !== "" &&
      selectedState !== "" &&
      selectedModel !== "" &&
      selectedModelYear !== "" &&
      selectedEngineHours !== ""
    ) {
      let requestPrice = {
        manufacturer: selectedManufacturer,
        model: selectedModel,
        "model year": selectedModelYear,
        state: selectedState,
        "engine hours": selectedEngineHours,
        other_expected_costs: "0",
        expected_tyre_cost: "0",
        dealer_margin: "0%",
      };

      props.getPricing({ requestPrice });
    } else if (
      selectedManufacturer !== "" &&
      selectedState !== "" &&
      selectedModel !== "" &&
      selectedModelYear !== "" &&
      selectedEngineHours !== "" &&
      selectedTyreHealth !== "" &&
      otherCost !== "" &&
      selectedMargin !== ""
    ) {
      let requestPrice = {
        manufacturer: selectedManufacturer,
        model: selectedModel,
        "model year": selectedModelYear,
        state: selectedState,
        "engine hours": selectedEngineHours,
        other_expected_costs: otherCost,
        expected_tyre_cost: selectedTyreHealth,
        dealer_margin: selectedMargin,
      };

      props.getPricing({ requestPrice });
    } else {
      Swal.fire({
        icon: "info",
        text: "All Fields are Mandatory",
        confirmButtonColor: "#652078",
      });
    }
  };

  const handleInfoClick = () => {
    Swal.fire({
      html: `<div style={{text-align:"center"}}>Like Documentation, RTO charges etc.</div>`,
      customClass: {
        container: "position-absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      confirmButtonColor: "#652078",
      toast: true,
      confirmButtonText: "Close",
      position: "bottom-center",
    });
  };

  const handleMarginInfoClick = () => {
    Swal.fire({
      html: `<div style={{text-align:"center"}}>Desired % margin on cost price of the tractor</div>`,
      customClass: {
        container: "position-absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      confirmButtonColor: "#652078",
      toast: true,
      confirmButtonText: "Close",
      position: "bottom-center",
    });
  };

  const handleRedirect = () => {
    window.location.href = window.location.href + "&submit.jotform.com/submit";
  };

  const handlePriceType = (event) => {
    setSelectedPriceType(event.target.value);
    if (event.target.value === "buying") {
      setOtherCost("");
      setSelectedMargin("");
      setSelectedTyreHealth("");
    }
  };

  return (
    <>
      <Header>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "5px",
            color: "#FFFF",
          }}
          onClick={handleRedirect}
        >
          {/* <BiArrowBack style={{color:'#FFFF', height:'40px', width:'25px',marginLeft:"10px"}} /> */}
          <p style={{ fontSize: "16px", fontWeight: "700" }}>
            {priceTypeQuery ? "Check Buying Price" : "Pricing Tool"}
          </p>
        </div>
      </Header>
      <Form onSubmit={handleSubmit} style={{ margin: "0px auto" }}>
        <Form.SectionContainer shadow={true}>
          <Form.Section
            style={{
              padding: "20px 20px",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            {!priceTypeQuery && (
              <div className="priceCategoryWrapper">
                <p className="priceCategoryHeader">See Pricing of</p>
                <div className="priceCategoryElement">
                  <div
                    className={
                      selectedPriceType === "selling"
                        ? "selectedPrice"
                        : "commonSelected"
                    }
                  >
                    <input
                      type="radio"
                      value="selling"
                      checked={selectedPriceType === "selling"}
                      onChange={handlePriceType}
                    />
                    <label className="priceCategoryLabel">SELLING</label>
                  </div>
                  <div
                    className={
                      selectedPriceType === "buying"
                        ? "selectedPrice"
                        : "commonSelected"
                    }
                  >
                    <input
                      type="radio"
                      value="buying"
                      checked={selectedPriceType === "buying"}
                      onChange={handlePriceType}
                    />
                    <label className="priceCategoryLabel">BUYING</label>
                  </div>
                </div>
              </div>
            )}
            <Fragment>
              <Form.GroupFields>
                <Form.Label htmlfor="manufacturer">
                  Manufacturer
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Form.Label>
                <div className="pricingFormWrapper">
                  <img src="../assets/manufacturer.svg" alt="" />
                  <Form.PricingDropdown
                    name="manufacturer"
                    id="manufacturer"
                    options={manufacturer}
                    onChange={(e) => setSelectedManufacturer(e.target.value)}
                  />
                </div>
              </Form.GroupFields>
              <Form.GroupFields>
                <Form.Label htmlfor="state">
                  State
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Form.Label>
                <div className="pricingFormWrapper">
                  <img src="../assets/state.svg" alt="" />
                  <Form.PricingDropdown
                    name="state"
                    id="state"
                    options={state}
                    onChange={(e) => setSelectedState(e.target.value)}
                  />
                </div>
              </Form.GroupFields>
              <Form.GroupFields>
                <Form.Label htmlfor="model">
                  Model
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Form.Label>
                <div className="pricingFormWrapper">
                  <img src="../assets/manufacturer.svg" alt="" />
                  <Form.PricingDropdown
                    name="model"
                    id="model"
                    options={model}
                    onChange={(e) => setSelectedModel(e.target.value)}
                  />
                </div>
              </Form.GroupFields>
              <Form.GroupFields>
                <Form.Label htmlfor="model_year">
                  Model Year
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Form.Label>
                <div className="pricingFormWrapper">
                  <img src="../assets/year.svg" alt="" />
                  <Form.PricingDropdown
                    name="model_year"
                    id="model_year"
                    options={pricingToolYear}
                    onChange={(e) => setSelectedModelYear(e.target.value)}
                  />
                </div>
              </Form.GroupFields>
              <Form.GroupFields>
                <Form.Label htmlfor="engine_hours">
                  Engine Hours
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Form.Label>
                <div className="pricingFormWrapper">
                  <img src="../assets/engine_hours.svg" alt="" />
                  <Form.PricingDropdown
                    name="engine_hours"
                    id="engine_hours"
                    options={engineHours}
                    onChange={(e) => setSelectedEngineHours(e.target.value)}
                  />
                </div>
              </Form.GroupFields>
            </Fragment>
            {selectedPriceType === "buying" && (
              <>
                <Form.GroupFields>
                  <Form.Label htmlfor="tyre_health">
                    Tyre Cost
                    <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                  </Form.Label>
                  <div className="pricingFormWrapper">
                    <img src="../assets/tyre_health.svg" alt="" />
                    <Form.PricingInput
                      name="tyre_health"
                      id="tyre_health"
                      type="number"
                      placeholder="Tyre Cost"
                      onChange={(e) => setSelectedTyreHealth(e.target.value)}
                    />
                  </div>
                </Form.GroupFields>
                <Form.GroupFields>
                  <div style={{ display: "flex" }}>
                    <Form.Label htmlfor="other_expected_costs">
                      Other Expected Costs
                      <span
                        style={{
                          color: "red",
                          marginLeft: "2px",
                          textAlign: "center",
                        }}
                      >
                        *
                      </span>
                    </Form.Label>
                    <FcInfo
                      style={{ width: "20px", height: "20px" }}
                      onClick={handleInfoClick}
                    />
                  </div>
                  <div className="pricingFormWrapper">
                    <img src="../assets/other_cost.svg" alt="" />
                    <Form.PricingInput
                      name="other_expected_costs"
                      id="other_expected_costs"
                      type="number"
                      placeholder="Other Costs"
                      onChange={(e) => setOtherCost(e.target.value)}
                    />
                  </div>
                </Form.GroupFields>
                <Form.GroupFields>
                  <div style={{ display: "flex" }}>
                    <Form.Label htmlfor="margin_percentage">
                      Dealer Margin %
                      <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                    </Form.Label>
                    <FcInfo
                      style={{ width: "20px", height: "20px" }}
                      onClick={handleMarginInfoClick}
                    />
                  </div>
                  <div className="pricingFormWrapper">
                    <Form.PricingDropdown
                      name="margin_percentage"
                      id="margin_percentage"
                      options={marginPercentage}
                      onChange={(e) => setSelectedMargin(e.target.value)}
                    />
                  </div>
                </Form.GroupFields>
              </>
            )}
          </Form.Section>
          <Form.ButtonContainer>
            {
              <Form.Button>
                {props.pricingDataLoading ? "SUBMITTING" : "SUBMIT"}
              </Form.Button>
            }
          </Form.ButtonContainer>
        </Form.SectionContainer>
      </Form>
    </>
  );
}

const mapStateToProps = (state) => ({
  manufacturerStateLoading: state.fetchManufacturerStateReducer.loading,
  manufacturerStateData: state.fetchManufacturerStateReducer.manufacturerState,
  pricingOthersData: state.fetchPricingOtherDetailReducer.pricingOtherDetail,
  pricingDataLoading: state.fetchPricingReducer.loading,
  pricingData: state.fetchPricingReducer.resPrice,
});

const mapDispatchToProps = (dispatch) => ({
  getManufacturerState: () => dispatch(fetchManufacturerStateRequest()),
  getPricingOtherDetail: ({ requestPricingOtherDetail }) => {
    dispatch(fetchPricingOtherDetailRequest({ requestPricingOtherDetail }));
  },
  getPricing: ({ requestPrice }) => {
    dispatch(fetchPricingRequest({ requestPrice }));
  },
  pricingReset: () => {
    dispatch(fetchPricingReset());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PricingTool);
